import {GetUserProjects} from "../../api/member";

const member = {
    namespaced: true,
    state: {
        memberInfo: {},
        userProjects: []
    },
    actions: {
        async getMyMember({state}, payload) {
            let rep = await abp.ajax.get('/api/services/app/Member/GetMyMember');
            state.memberInfo = {};
            state.memberInfo = rep.data.result;
            localStorage.setItem('MemberId', state.memberInfo.id);
            localStorage.setItem('isAuthentication', state.memberInfo.isAuthentication);
            localStorage.setItem('authenticationTime', state.memberInfo.authenticationTime);
            localStorage.setItem('brithDay', state.memberInfo.brithDay);
            localStorage.setItem('Select-ProjectId', state.memberInfo.lastProjectId);
        },
        async getUserProjects({state}, payload) {
            let rep = await GetUserProjects(payload.userId);
            state.userProjects = [];
            state.userProjects.push(...rep.data.result)

        }
    }
};
export default member;
